"use client";

import { ThemeModeSwitch } from "@/components/app/theme-mode-switch";

export function LandingThemeSwitch() {
  return <ThemeModeSwitch compact />;
}
